<template>
  <aside class="add-cover" v-show="isShowPicker">
    <div class="pcaPicker">
      <div class="tp-top fx fx-justify-between fx-align-center">
        <div class="pp-left" @click="apkClose">取消</div>
        <div class="pp-right" @click="apkOutput">确定</div>
      </div>
      <div class="tp-bd">
        <mt-picker
          :slots="slots"
          @change="onPcaPickerChange"
          :itemHeight="itemHeight"
          :visibleItemCount="5"
        >
        </mt-picker>
      </div>
    </div>
  </aside>
</template>
<script>
import pcaData from '@/assets/lib/pca.json';

export default {
  name: 'addrPicker',
  props: ['isShowPicker'],
  data() {
    return {
      slots: null,
      pVal: null,
      cVal: null,
      dVal: null,
      addrInfo: {
        mobile: '',
        name: '',
        address_area: '',
        address_detail: ''
      },
      isLockSend: true
    };
  },
  created() {
    this.init();
    this.getAddress();
  },
  computed: {
    itemHeight() {
      return 36 * document.documentElement.getAttribute('data-dpr');
    }
  },
  watch: {},
  methods: {
    init() {
      const daProvince = Object.keys(pcaData);
      this.pVal = daProvince[0];

      const daCity = Object.keys(pcaData[daProvince[0]]);
      this.cVal = daCity[0];

      const daDistrict = pcaData[daProvince[0]][daCity[0]];
      this.dVal = daDistrict[0];

      this.slots = [
        {
          flex: 1,
          values: daProvince,
          className: 'pca-slot',
          textAlign: 'center'
        },
        {
          divider: true,
          content: '-',
          className: 'pca-slot'
        },
        {
          flex: 1,
          values: daCity,
          className: 'pca-slot',
          textAlign: 'center'
        },
        {
          divider: true,
          content: '-',
          className: 'pca-slot'
        },
        {
          flex: 1,
          values: daDistrict,
          className: 'pca-slot',
          textAlign: 'center'
        }
      ];
    },
    onPcaPickerChange(picker, values) {
      if (values['0'] !== this.pVal) {
        // 省变了改动市
        let _oInfo = this.handelAddData({
          p: values[0]
        });
        picker.setSlotValues(1, _oInfo['aCity']);
        picker.setSlotValues(2, _oInfo['aDistrict']);
        this.pVal = values[0];
        this.cVal = _oInfo['sCity'];
        this.dVal = _oInfo['sDistrict'];
      } else if (values['0'] == this.pVal && values['1'] !== this.cVal) {
        // 市变了改动区
        let _oInfo = this.handelAddData({
          p: values[0],
          c: values[1]
        });
        picker.setSlotValues(2, _oInfo['aDistrict']);
        this.cVal = values[1];
        this.dVal = _oInfo['sDistrict'];
      } else {
        this.dVal = values[2];
      }
    },
    handelAddData(oData) {
      if (oData['p'] && !oData['c']) {
        // 改变市、区数据
        const daCity = Object.keys(pcaData[oData['p']]);
        const daDistrict = pcaData[oData['p']][daCity[0]];
        return {
          aCity: daCity,
          sCity: daCity[0],
          aDistrict: daDistrict,
          sDistrict: daDistrict[0]
        };
      } else {
        const daDistrict = pcaData[oData['p']][oData['c']];
        return {
          aDistrict: daDistrict,
          sDistrict: daDistrict[0]
        };
      }
    },
    apkClose() {
      this.$emit('cancel');
    },
    apkOutput() {
      this.$emit('ok', `${this.pVal} ${this.cVal} ${this.dVal}`);
    },
    getAddress() {}
  }
};
</script>

<style scoped lang="scss">
.add-warp {
  height: 100%;
}

.add-warp-in {
  margin: 0 32px;
}

.item-lst {
  box-sizing: border-box;
  height: 96px;
  border-bottom: 2px solid #ccc;
  display: flex;
  align-items: center;
  font-size: 26px;
}

.item-l {
  flex: 0 0 180px;
  color: #151515;
}

.item-m {
  flex: 1 1 auto;
  color: #1b1b1b;

  & input {
    color: #1b1b1b;
    width: 100%;
  }
}

.add-items {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;

  & input {
    flex: 1 1 auto;
    width: 100%;
  }
}

.item-r {
  flex: 0 0 180px;
}

.btn-add-select {
  display: flex;
  justify-content: flex-end;
  color: #9c9c9c;
}

.i-fs {
  font-size: 20px;
  transform: rotate(90deg);
  overflow: hidden;
  color: #9c9c9c;
  margin-left: 20px;
}

.btn-addr-warp {
  margin: 98px 84px 0 84px;
}

.pcaPicker {
  width: 100%;
  position: absolute;
  bottom: 0;
  height: 520px;
  background-color: #fff;
}

.tp-top {
  height: 92px;
  overflow: hidden;
  border-bottom: 2px solid #ccc;

  .pp-left,
  .pp-right {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1 1 auto;
    font-size: 32px;
    text-align: center;
  }

  .pp-left {
    color: #1b1b1b;
    border-right: 2px solid #ccc;
  }

  .pp-right {
    color: #ffb332;
  }
}

.tp-bd {
  margin-top: 40px;
}

.add-cover {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background: rgba(0, 0, 0, 0.7);
}
</style>
